import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { FeaturesModalProps } from './FeaturesModal.types';

export const renderFeaturesListMobileModal = (data: FeaturesModalProps) =>
    openPopupHelper({ popupName: popupNames.TARIFF_FEATURES_LIST_MOBILE, data });
